<template>
    <nav class="navbar navbar-fixed navbar-expand-lg" :class="{
        'scrolled': isHome ? (isLargeScreen && scrolled) : true
    }">
        <div class="container-fluid d-block p-0">
            <div class="row w-100 align-items-center">
                <!-- Columna 1: Logo (Imagen) -->
                <div class="col-3 col-lg-auto">
                    <!-- Asegúrate de que el botón esté fuera del col-1 d-lg-none -->
                    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasDarkNavbar" aria-controls="offcanvasDarkNavbar"
                        aria-label="Toggle navigation">
                        <i class="bx bx-list-ul" style="color: #06283c;"></i>
                    </button>
                </div>
                <div class="col-5 col-lg-2 d-flex align-items-center justify-content-center">
                    <router-link class="navbar-brand" :to="{ name: 'home' }">
                        <!-- Desktop grande, home, sin scroll → logo blanco -->
                        <img v-if="isHome && isLargeScreen && !scrolled"
                            :src="getAbsoluteImageUrl('/img/logo/app_white.png')" alt="Logo blanco"
                            class="logo-img img-fluid">

                        <!-- Desktop grande, home, con scroll → logo negro -->
                        <img v-else-if="isHome && isLargeScreen && scrolled"
                            :src="getAbsoluteImageUrl('/img/logo/app_dark.png')" alt="Logo negro"
                            class="logo-img img-fluid">

                        <!-- Tablets o móviles → logo negro siempre -->
                        <img v-else :src="getAbsoluteImageUrl('/img/logo/app_dark.png')" alt="Logo negro"
                            class="logo-img img-fluid">
                    </router-link>


                </div>

                <!-- Input de búsqueda -->
                <div class="col-lg-3 d-none d-lg-flex buscador-radio-personalizado">
                    <div class="input-group d-flex align-items-center w-100 position-relative text-ligth">
                        <!-- Contenedor del input -->
                        <div class="position-relative flex-grow-1">
                            <form @submit.prevent="busquedaEnter">
                                <input class="form-control" type="search"
                                    placeholder="Buscar por marca,modelo,año,código de parte,linea"
                                    :class="{ 'placeholder-scrolled': isHome ? (isLargeScreen && scrolled) : true }"
                                    @input="handleSearchInputDebounced" @keyup.enter="busquedaEnter" @blur="hideResults"
                                    autocomplete="off" v-model="inputValue" aria-label="Search">
                            </form>
                            <!-- Ícono de búsqueda / Cargando -->
                            <div class="search-icon-left">
                                <i v-if="!searching" class="fa fa-search" aria-hidden="true"></i>
                                <div v-else class="spinner-border spinner-border-sm text-dark spinner-icon"
                                    role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <!-- Ícono de micrófono -->
                            <div class="voice-icon-right" @click="startVoiceRecognition"
                                :class="{ 'active': isListeningVoice }">
                                <i class="fa fa-microphone" aria-hidden="true"></i>
                            </div>
                        </div>
                        <!-- 📌 Aquí van los resultados de búsqueda -->
                        <div v-if="(resultados.length > 0) && menuproductos"
                            class="category-list2 position-absolute w-100 bg-white shadow rounded border"
                            style="top: 100%; left: 0; z-index: 1000;">
                            <div class="column" v-if="resultados.length > 0">
                                <div class="group-header">
                                    &nbsp;<span class="badge text-bg-info text-white"><i
                                            class="fas fa-tag"></i></span>&nbsp;
                                    <span style="color: #333;font-size:16px;">Sugeridos: </span>
                                </div>
                                <ul class="list-unstyled">
                                    <li v-for="resultado in resultados" :key="resultado.id" class="p-2">
                                        <div class="nav-link2 d-flex flex-column align-items-start"
                                            @mousedown.prevent="handleResultClick(resultado)" style="cursor: pointer;">
                                            <!-- Clave del producto (k_parte) y Badges en la parte superior -->
                                            <div class="d-flex align-items-center">
                                                <h6 class="ms-2 mb-0" style="color:#06283c">{{ resultado.k_parte }}</h6>
                                                <div class="d-flex align-items-center ms-2">
                                                    <span class="badge bg-success me-2"
                                                        v-if="resultado.badgenuevo">Nuevo</span>
                                                    <!-- Otros Badges -->
                                                    <span class="badge-vino-fino" style="font-size: 10px;"
                                                        v-if="resultado.especial && resultado.especial !== 'False' && resultado.especial !== 'false'">
                                                        <i class="bx bx-crown" aria-hidden="true"></i> Recomendación
                                                        para ti
                                                    </span>
                                                    <span class="badge-vino-naranja" style="font-size: 10px;"
                                                        v-if="resultado.mejoresventas">
                                                        <i class="bx bx-award" aria-hidden="true"></i>&nbsp;Top
                                                        Ventas
                                                    </span>
                                                    <span class="badge-vino-azul" style="font-size: 10px;"
                                                        v-else-if="resultado.mejoresventaslineas">
                                                        <i class="bx bx-star" aria-hidden="true"></i>&nbsp;Top
                                                        Ventas Lineas
                                                    </span>
                                                </div>
                                            </div>
                                            <!-- Línea del producto debajo del k_parte -->
                                            <span class="ms-2 text-muted small">{{ resultado.linea }}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="column" v-if="masbuscados.length > 0">
                                <div class="group-header">
                                    &nbsp;<span class="badge text-bg-warning"><i class="fas fa-search"></i></span>
                                    &nbsp;
                                    <span style="color: #333;font-size:16px;">Últimas Búsquedas:</span>

                                </div>
                                <ul class="list-unstyled">
                                    <li v-for="buscados in masbuscados">
                                        <router-link class="nav-link2 d-block p-2" @click="ajusteclick"
                                            style="text-decoration: none;" :to="{
                                                name: 'ListadoProductos',
                                                params: {
                                                    prod: buscados.consulta,
                                                }
                                            }">
                                            <span class="text-warning">{{ buscados.consulta
                                            }}</span>
                                            <span class="ms-2 text-muted small">{{
                                                buscados.resultados }} Resultados</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>

                            <div class="column" v-if="mejoresVentas.length > 0">
                                <div class="group-header">
                                    &nbsp;<span class="badge text-bg-success"><i
                                            class="fas fa-shopping-bag"></i></span>&nbsp;
                                    <span style="color: #333;font-size:16px;">Más Vendidos: </span>
                                </div>
                                <ul class="list-unstyled">
                                    <li v-for="venta in mejoresVentas">
                                        <router-link class="nav-link2 d-block p-2" @click="ajusteclick"
                                            style="text-decoration: none;"
                                            :to="{ name: 'detalleProducto', query: { claveprod: venta.k_parte } }">
                                            <span class="text-success">{{ venta.k_parte }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Columna 3: Enlaces de navegación -->
                <div class="col-5 d-none d-lg-flex align-items-center justify-content-center gap-3">
                    <!-- Menú de navegación -->
                    <ul class="navbar-nav my-2 my-lg-0 navbar-nav-scroll" style="--bs-scroll-height: 100px;">
                        <li class="nav-item">
                            <router-link :to="{ name: 'home' }" class="nav-link active menuitem">
                                <span>Home</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/contacto" class="nav-link active menuitem">
                                <span>Contacto</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/ListBlogs" class="nav-link active menuitem">
                                <span>Blog</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/OurBrands" class="nav-link active menuitem">
                                <span>Nuestras Marcas</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/catalogosview" class="nav-link active menuitem">
                                <span>Catálogos</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="col-1 d-block d-lg-none">
                    <button class="btn p-0" data-bs-toggle="modal" data-bs-target="#openAdvancedSearchModalButton"
                        style="background: transparent; border: none; color: #06283c; font-size: 24px;">
                        <i class="bx bx-search"></i>
                    </button>
                </div>

                <!-- Columna 6: Botón de login -->
                <div class="col-1">
                    <div v-if="isLoggedin" class="cart-container d-flex align-items-center">
                        <div class="cart-left">
                            <div class="cart-top"
                                v-if="permissions_auth.includes('permission_compras') && !rol_auth.includes('Cotizador-Mostrador')">
                                <router-link :to="{ name: 'CartItemsList' }" type="button" class="btn position-relative"
                                    style="color:#ff9900; font-size: 18px;"> <!-- Aumentamos el tamaño del botón -->
                                    <i class="bx bx-cart fs-3"></i> <!-- Aumentamos el icono -->
                                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                                        style="background-color:white!important; color:#D97706!important; font-size: 14px; padding: 6px 10px;">
                                        {{ obtenerCantidadEnCarrito }}
                                    </span>
                                </router-link>
                            </div>
                        </div>
                        <div class="dropdown d-none d-lg-block ms-3">
                            <a class="btn dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <span class="cliente-info">
                                    {{ cliente_auth }}
                                </span>
                            </a>
                            <ul class="dropdown-menu">
                                <li v-if="rol_auth.includes('admin') || rol_auth.includes('CustomerService')">
                                    <router-link
                                        v-if="rol_auth.includes('admin') || rol_auth.includes('CustomerService')"
                                        to="/AdminDashboard" class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-desktop" aria-hidden="true"
                                            style="color:#06283c;"></i>&nbsp;
                                        Mi Cuenta
                                    </router-link>
                                </li>
                                <li v-else-if="rol_auth.includes('asesor')">
                                    <router-link to="/AsesorDashboard" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-desktop" aria-hidden="true"
                                            style="color:#06283c;"></i>&nbsp;
                                        Mi Cuenta
                                    </router-link>
                                </li>
                                <li v-else-if="rol_auth.includes('vendedor')" to="/TmkDashboard">
                                    <router-link to="/TmkDashboard" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-desktop" aria-hidden="true"
                                            style="color:#06283c;"></i>&nbsp;
                                        Mi Cuenta
                                    </router-link>
                                </li>
                                <li v-else-if="rol_auth.includes('cliente')" to="/dashboard">
                                    <router-link to="/dashboard" class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-desktop" aria-hidden="true"
                                            style="color:#06283c;"></i>&nbsp;
                                        Mi Cuenta
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('cliente')">
                                    <router-link :to="{ name: 'listadocotizaciones', query: { cliente: cliente_auth } }"
                                        class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>&nbsp;
                                        No Autorizados
                                    </router-link>

                                </li>
                                <li v-if="rol_auth.includes('cliente')">
                                    <router-link
                                        :to="{ name: 'listadocotizacionesaut', query: { cliente: cliente_auth } }"
                                        class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-check-circle" aria-hidden="true"></i>&nbsp;
                                        Autorizados
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('cliente') || rol_auth.includes('Cotizador-Mostrador')">
                                    <router-link to="/HelpCotizador" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-calculator" aria-hidden="true"></i>&nbsp;
                                        Cotizador
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('cliente')">
                                    <router-link to="/consultdocumentosSat" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-file-find" aria-hidden="true"></i>&nbsp;
                                        Doctos Eletrónicos
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin') || permissions_auth.includes('productos-read')">
                                    <router-link to="/Productos" class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-box" aria-hidden="true"></i>&nbsp;
                                        Productos
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin')">
                                    <router-link to="/actualizarprods" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-upload" aria-hidden="true"></i>&nbsp;
                                        Carga de productos
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin') || permissions_auth.includes('users-read')">
                                    <router-link :to="{ name: 'users', params: { ajustarMargin: 1 } }"
                                        class="dropdown-item"
                                        v-if="rol_auth.includes('admin') || permissions_auth.includes('users-read')"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-users" aria-hidden="true"></i>&nbsp;
                                        Usuarios
                                    </router-link>
                                </li>
                                <li
                                    v-if="rol_auth.includes('admin') || rol_auth.includes('MKTG') || permissions_auth.includes('banner-create')">
                                    <router-link to="/posts" class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-image" aria-hidden="true"></i>&nbsp;
                                        Banner's
                                    </router-link>
                                </li>
                                <li
                                    v-if="rol_auth.includes('admin') || rol_auth.includes('MKTG') || permissions_auth.includes('pdfcatalogo-create')">
                                    <router-link to="/documentoindexview" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-file-pdf" aria-hidden="true"></i>&nbsp;
                                        Documentos PDFS
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin')">
                                    <router-link to="/Correos" class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;
                                        Config. Correos
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin')">
                                    <router-link to="/DetailsErrosCarts" class="dropdown-item" style=" text-decoration:
                                        none;">
                                        &nbsp;<i class="fa fa-envelope" aria-hidden="true"></i>
                                        Detalles Carrito
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin')">
                                    <router-link to="/DetailsErrosProds" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="fa fa-envelope" aria-hidden="true"></i>
                                        Detalles Producto
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin')">
                                    <router-link to="/Sync" class="dropdown-item" style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-sync" aria-hidden="true"></i>&nbsp;
                                        Sync Prods
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin')">
                                    <router-link :to="{ name: 'documentosconsultSat' }" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-bullhorn" aria-hidden="true"></i>&nbsp;
                                        Admin Doctos Sat
                                    </router-link>
                                </li>
                                <li v-if="rol_auth.includes('admin')">
                                    <router-link :to="{ name: 'anunciosadmin' }" class="dropdown-item"
                                        style="text-decoration: none;">
                                        &nbsp;<i class="bx bx-bullhorn" aria-hidden="true"></i>&nbsp;
                                        Admin Anuncios
                                    </router-link>
                                </li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li style="display: flex; align-items: center;cursor: pointer;">
                                    &nbsp;<i class="bx bx-log-out"></i>&nbsp;
                                    <span class="dropdown-item" @click="logout">Salir</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-else class="btn" style="color:#ff9900;" @click="getLoginUrl">
                        Ingresar
                    </div>
                </div>
                <!-- Offcanvas -->

            </div>
            <div v-if="isLargeScreen">
                <div v-show="showLevel2" class="row px-3 pt-0">
                    <BusquedaAvanzada :is-large-screen="isLargeScreen" :scrolled="scrolled" :is-home="isHome" />
                </div>
            </div>
        </div>
    </nav>
    <div class="modal fade" id="openAdvancedSearchModalButton" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style="margin-top:22%">
        <div class="modal-dialog modal-sm-up">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title w-100 text-center fw-bold" style="color:#333;">
                        Búsqueda Avanzada
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Contenedor del input de búsqueda -->
                    <div class="position-relative flex-grow-1 mt-3">
                        <div class="search-container">
                            <div class="input-wrapper">
                                <input class="form-control" type="search" id="searchInputrespo" v-model="inputValue2" style="color: black!important;"
                                    aria-label="Search" autocomplete="off" @input="handleSearchInputDebounced2"
                                    @focus="hidePlaceholder" @blur="showPlaceholder" @keyup.enter="busquedaEnter2">
                                <div v-if="!inputValue2" class="animated-placeholder">
                                    Buscar por marca, modelo, año, código de parte, línea
                                </div>
                            </div>
                            <button class="btn btn-primary search-button" @click="busquedaEnter2">Buscar</button>
                        </div>
                        <!-- Ícono de búsqueda / Cargando -->
                        <div class="search-icon-left">
                            <i v-if="!searching" class="fa fa-search" aria-hidden="true"></i>
                            <div v-else class="spinner-border spinner-border-sm text-dark spinner-icon" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <!-- Resultados de búsqueda -->
                    <div v-if="resultadosResponsivos.length > 0" class="mt-3">
                        <div v-for="item in resultadosResponsivos" :key="item.k_parte"
                            class="result-item d-flex flex-row mb-3">
                            <!-- Información del producto -->
                            <div class="ms-3 d-flex flex-column justify-content-between"
                                @mousedown.prevent="handleResultClick(item)" style="cursor: pointer;">
                                <!-- Clave con Badge (Nuevo) en la misma fila -->
                                <div class="d-flex flex-row align-items-center">
                                    <h5 class="mb-0 me-2" style="color:#06283c">{{ item.k_parte }}</h5>
                                    <!-- Cambié a h5 para k_parte -->
                                    <span class="badge bg-success me-2" v-if="item.badgenuevo">Nuevo</span>
                                    <!-- Badge "Nuevo" -->
                                    <!-- Otros Badges -->
                                    <span class="badge-vino-fino" style="font-size: 10px;"
                                        v-if="item.especial && item.especial !== 'False' && item.especial !== 'false'">
                                        <i class="bx bx-crown" aria-hidden="true"></i>
                                        Recomendación para ti
                                    </span>
                                    <span class="badge-vino-naranja" style="font-size: 10px;" v-if="item.mejoresventas">
                                        <i class="bx bx-award" aria-hidden="true"></i>&nbsp;Top Ventas
                                    </span>
                                    <span class="badge-vino-azul" style="font-size: 10px;"
                                        v-else-if="item.mejoresventaslineas">
                                        <i class="bx bx-star" aria-hidden="true"></i>&nbsp;Top Ventas Lineas
                                    </span>
                                </div>
                                <!-- Descripción debajo -->
                                <p class="mb-0 mt-2">{{ item.descripcion || 'Descripción no disponible' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasDarkNavbar"
        aria-labelledby="offcanvasDarkNavbarLabel" style="background-color: #000;">
        <div class="offcanvas-header">
            <h5 id="offcanvasDarkNavbarLabel" class="text-light">Menú</h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pagos-recientes-container">
            <!-- Menú de navegación -->
            <div v-if="!isLargeScreen">
                <BusquedaAvanzada2 @cerrar-offcanvas="cerrarOffcanvas" />
            </div>
            <ul class="navbar-nav my-2 my-lg-0 navbar-nav-scroll text-light" style="color: white!important;">
                <li class="nav-item">
                    <router-link :to="{ name: 'home' }" class="nav-link active text-light">
                        <span>Home</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/contacto" class="nav-link active text-light">
                        <span>Contacto</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/ListBlogs" class="nav-link active text-light">
                        <span>Blog</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/OurBrands" class="nav-link active text-light">
                        <span>Nuestras Marcas</span>
                    </router-link>
                </li>
            </ul>

            <!-- Título Mis accesos -->
            <h6 class="text-light mt-4" v-if="isLoggedin">Mis accesos</h6>

            <!-- Menú de accesos según roles -->
            <ul class="navbar-nav my-2 my-lg-0 navbar-nav-scroll" v-if="isLoggedin">
                <li v-if="rol_auth.includes('admin') || rol_auth.includes('CustomerService')" class="nav-item">
                    <router-link to="/AdminDashboard" class="nav-link text-light">
                        <i class="bx bx-desktop" aria-hidden="true" style="color:#06283c;"></i> Mi Cuenta
                    </router-link>
                </li>
                <li v-else-if="rol_auth.includes('asesor')" class="nav-item">
                    <router-link to="/AsesorDashboard" class="nav-link text-light">
                        <i class="bx bx-desktop" aria-hidden="true" style="color:#06283c;"></i> Mi Cuenta
                    </router-link>
                </li>
                <li v-else-if="rol_auth.includes('vendedor')" class="nav-item">
                    <router-link to="/TmkDashboard" class="nav-link text-light">
                        <i class="bx bx-desktop" aria-hidden="true" style="color:#06283c;"></i> Mi Cuenta
                    </router-link>
                </li>
                <li v-else-if="rol_auth.includes('cliente')" class="nav-item">
                    <router-link to="/dashboard" class="nav-link text-light">
                        <i class="bx bx-desktop" aria-hidden="true" style="color:#06283c;"></i> Mi Cuenta
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('cliente')" class="nav-item">
                    <router-link :to="{ name: 'listadocotizaciones', query: { cliente: cliente_auth } }"
                        class="nav-link text-light">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> No Autorizados
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('cliente')" class="nav-item">
                    <router-link :to="{ name: 'listadocotizacionesaut', query: { cliente: cliente_auth } }"
                        class="nav-link text-light">
                        <i class="fa fa-check-circle" aria-hidden="true"></i> Autorizados
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('cliente') || rol_auth.includes('Cotizador-Mostrador')" class="nav-item">
                    <router-link to="/HelpCotizador" class="nav-link text-light">
                        <i class="fa fa-calculator" aria-hidden="true"></i> Cotizador
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('cliente') || rol_auth.includes('Cotizador-Mostrador')" class="nav-item">
                    <router-link to="/consultdocumentosSat" class="nav-link text-light">
                        <i class="bx bx-file-find" aria-hidden="true"></i> Doctos Eletrónicos
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin')" class="nav-item">
                    <router-link to="/Productos" class="nav-link text-light">
                        <i class="fa fa-box" aria-hidden="true"></i> Productos
                    </router-link>
                </li>

                <li v-if="rol_auth.includes('admin')" class="nav-item">
                    <router-link to="/actualizarprods" class="nav-link text-light">
                        <i class="fa fa-upload" aria-hidden="true"></i> Carga de productos
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin') || permissions_auth.includes('users-read')" class="nav-item">
                    <router-link to="/users" class="nav-link text-light">
                        <i class="fa fa-users" aria-hidden="true"></i> Usuarios
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin') || rol_auth.includes('MKTG') || permissions_auth.includes('banner-create')"
                    class="nav-item">
                    <router-link to="/posts" class="nav-link text-light">
                        <i class="fa fa-image" aria-hidden="true"></i> Banner's
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin') || rol_auth.includes('MKTG') || permissions_auth.includes('pdfcatalogo-create')"
                    class="nav-item">
                    <router-link to="/documentoindexview" class="nav-link text-light">
                        <i class="fa fa-file-pdf" aria-hidden="true"></i> Documentos PDFS
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin')" class="nav-item">
                    <router-link to="/Correos" class="nav-link text-light">
                        <i class="fa fa-envelope" aria-hidden="true"></i> Config. Correos
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin')" class="nav-item">
                    <router-link to="/DetailsErrosCarts" class="nav-link text-light">
                        <i class="fa fa-envelope" aria-hidden="true"></i> Detalles Carrito
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin')" class="nav-item">
                    <router-link to="/DetailsErrosProds" class="nav-link text-light">
                        <i class="fa fa-envelope" aria-hidden="true"></i> Detalles Producto
                    </router-link>
                </li>
                <li v-if="rol_auth.includes('admin')" class="nav-item">
                    <router-link to="/Sync" class="nav-link text-light">
                        <i class="bx bx-sync" aria-hidden="true"></i> Sync Prods
                    </router-link>
                </li>

                <li>
                    <hr class="dropdown-divider">
                </li>
                <li class="nav-item" style="display: flex; align-items: center;color:#FFD700;">
                    <i class="bx bx-log-out"></i>
                    <span class="nav-link" @click="logout">Salir</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { debounce } from 'lodash'
import { Offcanvas } from 'bootstrap'

import BusquedaAvanzada from '../../Home/busquedaavanzada.vue'
import BusquedaAvanzada2 from '../../Home/busquedaavanzada2.vue'

export default {
    components: {
        BusquedaAvanzada,
        BusquedaAvanzada2
    },
    data() {
        return {
            /*isLoggedin: window.Laravel.isLoggedin,*/
            maxHeight: '250px', // Altura máxima predeterminada del acordeón
            cliente_auth: window.Laravel.user ? window.Laravel.user.id : '',
            namecliente_auth: window.Laravel.user ? window.Laravel.user.name : '',
            rol_auth: window.Laravel.roles,
            permissions_auth: window.Laravel.permissions_auth,
            isLargeScreen: window.innerWidth >= 768,
            showList: false,
            searchExpanded: false,
            searching: false,
            inputValue: '',
            nav2: false,
            showSecondRow: false,
            showText: false,
            lineasBsuqe: '',
            lineasDispo: '',
            resultados: [],
            resultados2: [],
            masbuscados: [],
            mejoresVentas: [],
            isMenuOpen: false,
            showProducts: false,
            showUsers: false,
            showPedidos: false,
            isSubMenuOpen: false,
            menuproductos: false,
            sidebarOpenRespo: false,
            showSearchInput: false,
            isExpandedFooter: false,
            isMenuOpenRespo: false,
            showErrors: false,
            selectedYear: '',
            selectedMonth: '',
            showCaptcha: false,
            recaptchaToken: null,
            isOpen: false,
            activeSubMenu: null,
            queryVoz: "",          // Almacena el texto de la búsqueda
            recognition: null,  // Controla el reconocimiento de voz
            isListeningVoice: false,
            sucursalesDataPrincipal: {
                redes: [] // Evita que sea null o undefined
            },
            isSubMenuVisibleD: false,
            isSubMenuVisibleD: false,
            inputValue2: '',
            searching2: false,
            resultadosResponsivos: [],
            menuproductos: false,
            showLevel2: true,
            lastScroll: 0,
            scrolled: false,
        }
    },
    created() {
        window.addEventListener('resize', this.checkScreenSize);
        window.addEventListener("scroll", this.handleScroll);
        this.handleSearchInputDebounced = debounce(this.handleSearchInput, 100);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
        window.removeEventListener("scroll", this.handleScroll);
        document.removeEventListener('click', this.closeSearchResults);
    },
    mounted() {
        this.$store.dispatch('obtenerCantidadEnCarrito');
        this.CargaBusquedas()
    },
    computed: {
        obtenerCantidadEnCarrito() {
            //console.log(this.$store.getters.obtenerCantidadEnCarrito)
            return this.$store.getters.obtenerCantidadEnCarrito;
        },
        isLoggedin() {

            return this.$store.getters.isLoggedin
        },
        logoSrc() {
            let logoPath;

            // Si estamos en desktop grande y hay scroll, mostramos logo oscuro
            if (this.isLargeScreen && this.scrolled) {
                logoPath = '/img/logo/app_dark.png';
            } else {
                // Logo blanco o default
                logoPath = '/img/logo/app_dark.png';
            }

            return this.getAbsoluteImageUrl(logoPath);
        },
        isHome() {
            return this.$route.name === 'home';   // o this.$route.path === '/'
        }
    },
    watch: {
        isLoggedin(newStatus) {
            if (!newStatus) {
                // Código para manejar cuando el usuario se desloguea
            }
        },
    },
    methods: {
        checkScreenSize() {
            // 💡 MODIFICACIÓN: Cambiamos 768px a 992px para coincidir con el CSS @media (min-width: 992px)
            this.isLargeScreen = window.innerWidth >= 992;
        },
        hidePlaceholder() {
            this.inputValue2 = ''; // Borra el placeholder al hacer focus
            this.menuproductos = true;
        },
        showPlaceholder() {
            if (!this.inputValue2) {
                this.inputValue2 = ''; // Muestra el placeholder si está vacío
                this.menuproductos = false;
            }

        },
        handleSearchInputDebounced2: _.debounce(function () {
            this.handleSearchInput2();
        }, 200),
        showSubMenu() {
            this.isSubMenuVisibleD = true; // Muestra el submenú al pasar el mouse
        },
        hideSubMenu() {
            this.isSubMenuVisibleD = false; // Oculta el submenú al dejar de pasar el mouse
        },
        toggleMenuNuevo() {
            this.isOpen = !this.isOpen;
        },
        toggleSubMenu(name) {
            this.activeSubMenu = this.activeSubMenu === name ? null : name;
        },
        handleSubItemClick() {
            this.isOpen = false;
            this.activeSubMenu = null;
        },
        getLoginUrl() {
            //return '/Ingresa';
            window.location.href = `${window.location.origin}/Ingresa`;
        },
        toggleMenuResponsive() {
            this.sidebarOpenRespo = !this.sidebarOpenRespo;
        },
        toggleExpandedFooter() {
            this.isExpandedFooter = !this.isExpandedFooter; // Cambia el estado de expansión
        },
        handleDashboardClick() {
            // Aquí puedes realizar la acción que desees al hacer clic en el enlace
            this.isMenuOpen = false,
                this.showProducts = false,
                this.showUsers = false,
                this.isSubMenuOpen = false
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        cargainicial() {
            this.busquedarest()
            this.CargaBusquedas()
        },
        getAbsoluteImageUrl(relativeUrl) {
            // Obtén la URL base de Laravel
            const baseUrl = window.location.origin;

            // Concatena la URL base con la ruta relativa de la imagen
            return baseUrl + relativeUrl;
        },
        toggleList2() {
            // Cambiar el estado de showList al hacer clic en el botón
            this.nav2 = !this.nav2;


            // Otros cambios que quieras hacer al hacer clic en el botón
        },
        toggleList() {
            this.showList = !this.showList;
            this.shrinkSearchInput();
            this.llenadatos();
        },
        closeList() {
            this.$store.dispatch('resetConsulta');
            this.showList = false;
        },
        expandSearchInput() {
            this.showList = false;
            this.searchExpanded = true;
            this.CargaBusquedas()
            if (this.inputValue != '')
                this.busquedarest()
            else
                this.resultados = []
            this.menuproductos = true;



        },
        async handleSearchInput() {
            this.searching = true;
            this.showSpinnerIcon = true;
            this.showList = false;
            if (this.inputValue.length >= 3) {
                try {
                    const response = await axios.get(`/search/${this.inputValue}`);
                    this.resultados = response.data;
                    this.resultados2 = response.data;
                    this.menuproductos = true;
                } catch (error) {
                    console.error(error);
                } finally {
                    this.showSpinnerIcon = false;
                    this.searching = false;
                    this.menuproductos = true;

                }
            } else {
                this.resultados = [];
                this.menuproductos = false;
                this.searching = false;
                this.menuproductos = false;

            }
        },
        async handleSearchInput2() {
            this.searching2 = true;
            this.showSpinnerIcon2 = true;
            this.showList2 = false;

            if (this.inputValue2.length >= 3) {
                try {

                    const response = await axios.get(`/search/${this.inputValue2}`);
                    console.log(response)
                    this.resultadosResponsivos = response.data;

                } catch (error) {
                    console.error(error);
                } finally {
                    this.showSpinnerIcon2 = false;
                    this.searching2 = false;


                }
            } else {
                this.resultadosResponsivos = [];

                this.searching2 = false;
            }
        },
        shrinkSearchInput() {
            this.searchExpanded = false;

        },
        clearSearchText() {
            this.inputValue = ''; // Borrar el texto del input
            this.resultados = [];
            this.shrinkSearchInput();
        },
        /*handleScroll() {
            // Lógica para mostrar/ocultar la segunda fila según el scroll
            if (window.scrollY > 100) {
                this.showSecondRow = true;
            } else {
                this.showSecondRow = false;
            }
        },*/
        hideResults() {
            // Ocultar resultados solo si ni el input ni los resultados están siendo enfocados
            if (!this.inputFocused && !this.resultsFocused) {
                this.menuproductos = false;
            }
        },
        llenadatos() {

            axios.get(`/catalogo/list`)
                .then((response) => {
                    //console.log(response.data)
                    this.lineasBsuqe = response.data.listyear;
                    this.lineasDispo = response.data.lineas;
                    //console.log(this.lineasDispo)
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        CargaBusquedas() {
            axios.get(`/api/home/buscados`)
                .then((response) => {
                    //this.showSpinnerIcon = false;
                    //console.log(response)
                    this.masbuscados = response.data.masbuscados;
                    this.mejoresVentas = response.data.mejoresVentas;
                });
        },
        async busquedarest() {
            if (this.inputValue.length >= 3) {
                try {
                    this.isSearching = true; // Indicar que se está realizando una búsqueda

                    // Esperar a que se complete la búsqueda
                    await axios.get(`/search/${this.inputValue}`)
                        .then((response) => {
                            this.showSpinnerIcon = false;
                            this.resultados = response.data;
                            this.resultados2 = response.data;
                        });

                } catch (error) {
                    console.error(error);
                } finally {
                    this.isSearching = false; // Indicar que la búsqueda ha terminado
                }
            }
        },

        async busquedaEnter() {
            this.$store.dispatch('resetConsultaEnter');
            if (this.inputValue.length >= 3) {
                if (!this.searching) {
                    await this.handleSearchInput(); // Esperar a que handleSearchInput termine
                    this.menuproductos = false;
                    this.resultados = [];
                    this.masbuscados = [];
                    this.mejoresVentas = [];

                    const prods = this.inputValue;
                    this.inputValue = '';

                    this.$router.push({
                        name: 'ListadoProductos',
                        query: { busqueda: prods }
                    });
                }
            }
        },
        async busquedaEnter2() {
            this.$store.dispatch('resetConsultaEnter');
            $('#openAdvancedSearchModalButton').modal('hide');
            if (this.inputValue2.length >= 3) {

                if (!this.searching2) {
                    await this.handleSearchInput(); // Esperar a que handleSearchInput termine
                    this.menuproductos2 = false;
                    this.resultadosResponsivos = [];
                    this.masbuscados = [];
                    this.mejoresVentas = [];

                    const prods = this.inputValue2;
                    this.inputValue2 = '';
                    console.log(this.inputValue2)
                    //this.$router.push({ name: 'ListadoProductos', params: { productobusqueda: prods } });
                    this.$router.push({
                        name: 'ListadoProductos',
                        query: { busqueda: prods }
                    });
                }
            }
        },
        handleItemClick() {
            // Do something with the clicked item (e.g., navigate to the details page)
            // Close the search results container
            this.inputValue = '';
            this.resultados = [];
            this.masbuscados = [];
            this.mejoresVentas = [];
        },
        ajusteclick() {

            // Ejecutar acciones solo si no se hizo clic en un <router-link>
            this.searchExpanded = false;
            this.inputValue = '';
            this.resultados = [];

        },
        closeSearchResults(event) {
            // Verificar si se hizo clic dentro del área del input de búsqueda o en la lista de resultados
            const searchInput = document.getElementById('inputsearch');
            const searchResults = document.getElementById('divresultados');
            if (searchInput.contains(event.target) || searchResults.contains(event.target)) {
                return;
            }

            // Si se hizo clic fuera del área del input de búsqueda y de los resultados de búsqueda, cerrar la lista de resultados
            this.inputValue = '';
            this.resultados = [];
            // Aquí puedes agregar otras acciones si es necesario
        },
        logout() {
            //axios.post('logout')
            axios.post(`${window.location.origin}/logout`)
                .then(response => {
                    // Manejar la respuesta si es necesario
                    //console.log('Logout exitoso');
                    // Actualizar window.Laravel para indicar que el usuario no está autenticado

                    window.location.href = `${window.location.origin}/home`;
                })
                .catch(error => {
                    // Manejar errores si es necesario
                    console.error('Error al hacer logout', error);
                });
        },
        handleBlur() {
            this.menuproductos = false
            this.isSearching = false
            this.searchExpanded = false
        },
        toggleSidebarRespo() {
            //console.log(this.sidebarOpenRespo)
            this.sidebarOpenRespo = !this.sidebarOpenRespo;
        }, toggleSearchInput() {
            this.showSearchInput = !this.showSearchInput;
        },
        verProducto(id) {
            // Realiza cualquier lógica adicional aquí, si es necesario
            // Por ejemplo, puedes validar algo antes de navegar a la página del producto

            // Luego, navega a la página del producto utilizando router.push()
            this.$router.push({ name: 'detalleProducto', query: { claveprod: id } });
            this.menuproductos = false
        },
        handleResultClick(resultado) {
            // Vaciar el valor del input
            this.inputValue = '';
            this.searchExpanded = false;




            // Limpiar los resultados de búsqueda
            this.resultados = [];
            this.resultadosResponsivos = [];
            // Cerrar el menú de productos
            this.menuproductos = false;
            // Llamar a la función verProducto
            $('#openAdvancedSearchModalButton').modal('hide');
            this.verProducto(resultado.k_parte);
        },
        startVoiceRecognition() {
            // Verificar si el navegador soporta la Web Speech API
            if (!('webkitSpeechRecognition' in window)) {
                this.error = "Tu navegador no soporta búsqueda por voz.";
                return;
            }

            // Inicializar el reconocimiento de voz
            this.recognition = new webkitSpeechRecognition();
            this.recognition.lang = "es-MX"; // Configura el idioma
            this.recognition.continuous = false; // No escucha continuamente
            this.recognition.interimResults = false; // No resultados intermedios

            // Evento cuando se recibe un resultado
            this.recognition.onresult = (event) => {
                this.queryVoz = event.results[0][0].transcript; // Captura el texto de la voz
                this.error = null; // Limpia errores previos
                this.isListeningVoice = false;
                this.$router.push({ name: 'ListadoProductos', query: { busqueda: this.queryVoz } });
            };

            // Manejo de errores
            this.recognition.onerror = (event) => {
                console.error("Error en reconocimiento de voz:", event);
                if (event.error === "not-allowed") {
                    this.error = "Permiso denegado. Activa el micrófono en tu navegador.";
                } else {
                    this.error = "Ocurrió un error al procesar tu voz.";
                }
                this.isListeningVoice = false;
            };

            // Iniciar el reconocimiento de voz
            this.isListeningVoice = true;
            this.recognition.start();
        },
        getImageUrl(item) {
            try {
                // Verifica si item.PicturesUrl existe y tiene contenido
                if (!item.PicturesUrl || Object.keys(item.PicturesUrl).length === 0) {
                    return null;
                }

                // Intenta obtener la clave correcta basada en la categoría/marca
                let index = item.categorias[0]?.marcas?.viewimagesprinc ?? 4;

                // Manejo de los dos posibles formatos (con "0" o sin él)
                let imagenObj = item.PicturesUrl["0"]?.stdClass ?? item.PicturesUrl.stdClass;

                return imagenObj?.sm || null;
            } catch (error) {
                console.error("Error obteniendo la imagen:", error);
                return null;
            }
        },
        handleScroll() {
            const currentScroll = window.scrollY;

            // 💡 ADICIÓN: Lógica para el cambio de fondo (transparente a negro)
            // Cambia a true si el scroll supera los 50px
            this.scrolled = currentScroll > 50;

            // === Tu Lógica Original de Dirección de Scroll ===
            if (currentScroll > this.lastScroll) {
                // Scroll hacia abajo
                this.showLevel2 = false;
            } else {
                // Scroll hacia arriba
                this.showLevel2 = true;
            }
            this.lastScroll = currentScroll;
        },
        cerrarOffcanvas() {
            const offcanvasElement = document.getElementById('offcanvasDarkNavbar')
            const offcanvasInstance = Offcanvas.getInstance(offcanvasElement)

            if (offcanvasInstance) {
                offcanvasInstance.hide()
            }
        }
    }
}
</script>
<style scoped>
/* ================================================= */
/* 1. ESTADO BASE (MÓVIL Y GENERAL) */
/* ================================================= */
.navbar-fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;

    background-color: #fff;
    color: #000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: background-color 0.4s ease, box-shadow 0.4s ease;
}

/* Textos e íconos — MÓVIL = NEGRO */
.navbar-fixed .menuitem span,
.navbar-fixed .cart-container i,
.navbar-fixed .dropdown-toggle {
    color: #000;
}

/* Buscador base */
input.form-control {
    border: 1px solid #ccc;
    padding-left: 30px;
    padding-right: 35px;
    color: white; /* texto blanco por defecto si fondo transparente */
}
@media (max-width: 991px) {
    .logo-img {
        height: 40px;
    }
}
/* ================================================= */
/* 2. DESKTOP SIN SCROLL (TRANSPARENTE) */
/* ================================================= */
@media (min-width: 992px) {
    .logo-img {
        height: 70px;
        transform: scaleX(1.5);
        /* zoom solo en ancho */
        transform-origin: center center;
        /* Crecimiento desde el centro */
        transition: opacity 0.3s ease;
        /* Cambio suave de imagen */
    }

    /* Navbar transparente */
    .navbar-fixed:not(.scrolled) {
        background-color: transparent !important;
        box-shadow: none !important;
    }

    /* Input transparente */
    .navbar-fixed:not(.scrolled) input.form-control {
        background-color: transparent !important;
        border: 1px solid transparent !important;
    }

    /* Textos NEGROS sobre fondo transparente */
    .navbar-fixed:not(.scrolled) .menuitem span,
    .navbar-fixed:not(.scrolled) .cart-container i,
    .navbar-fixed:not(.scrolled) .dropdown-toggle {
        color: #fff !important;
    }
}

/* ================================================= */
/* 3. DESKTOP CON SCROLL (NAVBAR BLANCO) */
/* ================================================= */
.navbar-fixed.scrolled {
    background-color: #fff !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

/* Textos negros para navbar blanco */
.navbar-fixed.scrolled .menuitem span,
.navbar-fixed.scrolled .cart-container i,
.navbar-fixed.scrolled .dropdown-toggle {
    color: #000 !important;
}

/* ================================================= */
/* BUSCADOR (ICONOS CAMBIAN SEGÚN ESTADO) */
/* ================================================= */
.navbar-fixed .search-icon-left,
.navbar-fixed .voice-icon-right {
    color: white;
}

.navbar-fixed.scrolled .search-icon-left,
.navbar-fixed.scrolled .voice-icon-right {
    color: #06283c;
    /* tu color marca */
}

.navbar-fixed.scrolled input.form-control {
    background-color: white !important;
    border: 1px solid white !important;
    color: #06283c !important;
}

/* ================================================= */
/* ESTILOS VARIOS */
/* ================================================= */

.logo-img {
    /* Zoom ligero */
    transform-origin: center;
    transition: height 0.3s ease, transform 0.3s ease;
}

.menuitem {
    position: relative;
    text-decoration: none;
}

/* Línea debajo del menú */
.menuitem::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: #000;
    /* se ajusta según estado */
    border-radius: 5px;
    transform: scaleX(0);
    transition: transform 0.5s ease;
    bottom: 0;
    left: 0;
}

/* Si quisieras que en scroll fuera blanca la línea, descomenta: */
/*
.navbar-fixed.scrolled .menuitem::before {
    background: white !important;
}
*/

/* Hover */
.menuitem:hover::before {
    transform: scaleX(1);
}

.menuitem:hover span {
    color: #ff9900 !important;
}
.form-control.placeholder-scrolled {
    color: #000; /* texto negro cuando scrolleaste o fondo blanco */
}
/* Placeholder normal */
.form-control::placeholder {
    color: #fff;
    opacity: 1;
}

/* Placeholder cuando se aplica la clase */
.form-control.placeholder-scrolled::placeholder {
    color: #9aa0a6;
    /* o el color que quieras */
}

.form-control.placeholder-scrolled::placeholder {
    color: #9aa0a6;
}

.form-control.placeholder-scrolled::-webkit-input-placeholder {
    color: #9aa0a6;
}

.form-control.placeholder-scrolled::-moz-placeholder {
    color: #9aa0a6;
}

.form-control.placeholder-scrolled:-ms-input-placeholder {
    color: #9aa0a6;
}
/* Search box */
.search-icon-left {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.voice-icon-right {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
}

.search-container {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
}

.input-wrapper {
    position: relative;
    flex-grow: 1;
    overflow: hidden;
}

#searchInputrespo {
    width: 100%;
    padding-right: 50px;
    background: transparent;
}

/* Placeholder animado */
.animated-placeholder {
    position: absolute;
    top: 20%;
    left: 10px;
    transform: translateY(-50%);
    white-space: nowrap;
    color: #06283c;
    animation: move-placeholder 5s linear infinite;
}

@keyframes move-placeholder {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(-100%);
    }
}
</style>